import React from 'react';
import { Image } from '@colonist/ui';
import { emptyTranslation } from '@colonist/i18n';
import IconReplay from '@static/images/icon_replay.svg';
import styles from './ReplayCell.module.scss';
export const ReplayCell = ({ replayUrl, gameId, onReplayClick })=>{
    const handleClick = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        onReplayClick(gameId, replayUrl);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.replay
    }, replayUrl != undefined && /*#__PURE__*/ React.createElement("a", {
        href: replayUrl,
        onClick: handleClick
    }, /*#__PURE__*/ React.createElement(Image, {
        image: {
            src: IconReplay,
            alt: emptyTranslation
        }
    })));
};
